export default __webpack_public_path__ + "static/media/screen8.ddedd278.svg";